let webengage_init = (code) => ``;

export default webengage_init;
